import { getLoketBridgeApiUrl } from '@/helpers/api-ts/loket'
import { generateUuid } from '@/helpers/tools'
import { PayslipResource, UserDocumentViewModel } from '@/models'

export function transformPayslipResourceToUserDocument(
    payslip: PayslipResource,
): UserDocumentViewModel {
    return {
        id: generateUuid(),
        isLoketFile: true,
        isDataUrl: false,
        createdAt: new Date(payslip.payrollPeriodStart),
        displayName: payslip.fileName,
        documentType: {
            id: generateUuid(),
            name: 'Salary',
            slug: 'salary',
        },
        downloadUrl: `${getLoketBridgeApiUrl()}/${payslip.downloadUrl}`,
        fileName: payslip.fileName,
    }
}
